/**
 * Provides exhaustiveness checks at compile time, throwing exceptions at
 * runtime when hit.
 *
 * Usage:
 *    const fruit: 'apples' | 'durian' = ...
 *    switch(fruit) {
 *     case 'apples':
 *       return 'yum';
 *     case 'durian':
 *       return 'yuck';
 *     default:
 *       absurd(fruit, `Unexpected fruit ${fruit}. A surprise to be sure, but a welcome one!`)
 *   }
 *   // If you add a new fruit `| 'oranges'` to the union, it will fail to
 *   // compile.
 */
export const absurd = (x: never, message = 'absurd'): never => {
  throw new Error(message);
};
